import { Link, type LinkProps } from 'react-router-dom';
import {
  AppButtonContent,
  appButtonClassName,
  type AppButtonSharedProps,
} from './AppButton';

export type LinkButtonProps = Omit<LinkProps, 'title'> & AppButtonSharedProps;

export function LinkButton({
  title,
  icon,
  iconPosition = 'left',
  children,
  className,
  variant,
  ...linkProps
}: LinkButtonProps) {
  return (
    <Link {...linkProps} className={appButtonClassName(className, variant)}>
      <AppButtonContent icon={icon} iconPosition={iconPosition}>
        {children ?? title}
      </AppButtonContent>
    </Link>
  );
}
